<div class="row">

  <div class="col-12 col-md-3 d-none d-md-block">
    <div class="list-group bg-white p-2">
      <a
        href class="list-item color-gray-300 fw-500 fs-normal"
        [class.active]="spy.active === 'account-info'"
        (click)="spy.scrollTo('account-info'); $event.preventDefault()"
      >
        {{'account.account_info'|translate}}
      </a>
      <a
        href class="list-item color-gray-300 fw-500 fs-normal"
        [class.active]="spy.active === 'profile-info'"
        (click)="spy.scrollTo('profile-info'); $event.preventDefault()"
      >
        {{'account.profile_info'|translate}}
      </a>
      <a
        href class="list-item color-gray-300 fw-500 fs-normal"
        [class.active]="spy.active === 'google-info'"
        (click)="spy.scrollTo('google-info'); $event.preventDefault()"
      >
        {{'account.google.title'|translate}}
      </a>
      <a
        href class="list-item color-gray-300 fw-500 fs-normal"
        [class.active]="spy.active === 'security-info'"
        (click)="spy.scrollTo('security-info'); $event.preventDefault()"
      >
        {{'account.change_password'|translate}}
      </a>
    </div>
  </div>

  <div class="col-12 col-md-9">
    <div ngbScrollSpy #spy="ngbScrollSpy" rootMargin="16px" class="scrollable-content">

    <div ngbScrollSpyFragment="account-info" class="account-card p-4" *ngIf="coach">
      <p class="fs-normal fw-800 color-gray-950 mb-3">{{'account.account_info'|translate}}</p>

      <div class="row">
        <div class="col-12 col-md-4">
          <label class="color-gray-500 fw-500 fs-small">{{'labels.name'|translate}}</label>
          <p class="fs-normal fw-500 color-gray-950 mb-0">{{coach.name}}</p>
        </div>
        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <label class="color-gray-500 fw-500 fs-small">{{'labels.mail'|translate}}</label>
          <p class="fs-normal fw-500 color-gray-950 mb-0">{{coach.email}}</p>
        </div>
        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <label class="color-gray-500 fw-500 fs-small">{{'labels.phone'|translate}}</label>
          <p class="fs-normal fw-500 color-gray-950 mb-0">{{coach.phone || '-'}}</p>
        </div>
      </div>

      <p class="fs-small fw-400 color-gray-400 mt-3 mb-0">{{'account.contact_info_note'|translate}}</p>
    </div>

    <form
        ngbScrollSpyFragment="profile-info" class="account-card p-4 mt-3"
        [formGroup]="fg" (ngSubmit)="onSubmit()">
      <p class="fs-normal fw-800 color-gray-950 mb-3">{{'account.profile_info'|translate}}</p>

      <div class="row">

        <div class="col-12">
          <label class="color-gray-500 fw-500 fs-small">{{'account.specialization'|translate}}</label>
          <app-gray-text-input
            [hasErr]="isSubmitted && fg.get('specialization')?.invalid"
            [placeholder]="'account.specialization_placeholder'|translate"
            formControlName="specialization"></app-gray-text-input>
        </div>

        <div class="col-12 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.bio'|translate}}</label>
          <textarea
            class="account-textarea w-100"
            formControlName="bio"
            [placeholder]="'account.bio_placeholder'|translate"></textarea>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.education'|translate}}</label>
          <app-gray-text-input
            [hasErr]="isSubmitted && fg.get('education')?.invalid"
            [placeholder]="'account.education_placeholder'|translate"
            formControlName="education"></app-gray-text-input>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.university'|translate}}</label>
          <app-gray-text-input
            [hasErr]="isSubmitted && fg.get('university')?.invalid"
            [placeholder]="'account.university_placeholder'|translate"
            formControlName="university"></app-gray-text-input>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.department'|translate}}</label>
          <app-gray-text-input
            [hasErr]="isSubmitted && fg.get('department')?.invalid"
            [placeholder]="'account.department_placeholder'|translate"
            formControlName="department"></app-gray-text-input>
        </div>

        <div class="col-12 col-md-3 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.graduation_year'|translate}}</label>
          <app-gray-text-input
            type="number" [isNumber]="true"
            [hasErr]="isSubmitted && fg.get('graduationYear')?.invalid"
            placeholder="2015"
            formControlName="graduationYear"></app-gray-text-input>
          <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('graduationYear')?.errors">
            <p>{{'account.graduation_year_range'|translate}}</p>
          </div>
        </div>

        <div class="col-12 col-md-3 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.experience_years'|translate}}</label>
          <app-gray-text-input
            type="number" [isNumber]="true"
            [hasErr]="isSubmitted && fg.get('experienceYears')?.invalid"
            placeholder="5"
            formControlName="experienceYears"></app-gray-text-input>
          <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('experienceYears')?.errors">
            <p>{{'account.experience_years_range'|translate}}</p>
          </div>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.birth_date'|translate}}</label>
          <app-gray-date-picker-input
            navigation="select" [maxDate]="birthMaxDate"
            formControlName="birthDate"></app-gray-date-picker-input>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.city'|translate}}</label>
          <app-gray-select-input
            [items]="cities" bindLabel="name" bindValue="id"
            [searchable]="true" [searchFn]="searchFn"
            [placeholder]="'account.city'|translate"
            formControlName="cityId"></app-gray-select-input>
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label class="color-gray-500 fw-500 fs-small">{{'account.hometown_city'|translate}}</label>
          <app-gray-select-input
            [items]="cities" bindLabel="name" bindValue="id"
            [searchable]="true" [searchFn]="searchFn"
            [placeholder]="'account.hometown_city'|translate"
            formControlName="hometownCityId"></app-gray-select-input>
        </div>

        <div class="col-12 mt-3">
          <label class="color-gray-500 fw-500 fs-small d-block mb-2">{{'account.gender'|translate}}</label>
          <app-gray-pill-select-input
            [items]="genders" bindValue="id" bindLabel="name"
            formControlName="gender"></app-gray-pill-select-input>
        </div>

      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-4">
          <app-gray-button
            type="submit" color="primary" [isLoading]="isLoading" [disabled]="isLoading"
            [text]="'buttons.save'|translate"></app-gray-button>
        </div>
      </div>

    </form>

    <div ngbScrollSpyFragment="google-info" class="account-card p-4 mt-3">
      <p class="fs-normal fw-800 color-gray-950 mb-1">
        <i class="bi bi-google color-brand-primary me-2"></i>{{'account.google.title'|translate}}
      </p>
      <p class="fs-small fw-400 color-gray-500 mb-3">{{'account.google.description'|translate}}</p>

      <ul class="google-benefits fs-small fw-400 color-gray-500 mb-3">
        <li>{{'account.google.benefit_calendar'|translate}}</li>
        <li>{{'account.google.benefit_meet'|translate}}</li>
        <li>{{'account.google.benefit_sync'|translate}}</li>
      </ul>

      <ngx-skeleton-loader
        *ngIf="googleIsLoading && !googleStatus" count="1" appearance="line"
        [theme]="{height: '56px', 'border-radius': '12px', margin: '0'}"/>

      <ng-container *ngIf="googleStatus">
        <div class="google-status d-flex flex-column flex-md-row align-items-md-center justify-content-between p-3"
             [class.connected]="googleStatus.connected">
          <div>
            <p class="fs-small fw-800 color-gray-950 mb-0">
              <i class="bi me-1" [class.bi-check-circle-fill]="googleStatus.connected"
                 [class.bi-exclamation-circle]="!googleStatus.connected"></i>
              {{(googleStatus.connected ? 'account.google.state_connected' : 'account.google.state_disconnected')|translate}}
            </p>
            <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="googleStatus.connected">
              {{googleStatus.googleEmail}}
              <span *ngIf="googleStatus.connectedAt">
                · {{'account.google.connected_at'|translate: {date: (googleStatus.connectedAt | date: 'd MMMM y')} }}
              </span>
            </p>
            <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="!googleStatus.connected">
              {{'account.google.disconnected_desc'|translate}}
            </p>
          </div>

          <div class="mt-3 mt-md-0">
            <app-gray-button
              *ngIf="!googleStatus.connected"
              color="primary" [fullWidth]="false" padding="px-3 py-2" [weight]="800" customClass="fs-small"
              [isLoading]="googleIsConnecting" [disabled]="googleIsConnecting"
              [text]="'account.google.connect'|translate" (click)="connectGoogle()"></app-gray-button>

            <app-gray-button
              *ngIf="googleStatus.connected"
              color="stroke" [fullWidth]="false" padding="px-3 py-2" [weight]="500" customClass="fs-small"
              [disabled]="googleIsLoading"
              [text]="'account.google.disconnect'|translate" (click)="confirmDisconnectGoogle()"></app-gray-button>
          </div>
        </div>
      </ng-container>
    </div>

    <form
        ngbScrollSpyFragment="security-info" class="account-card p-4 mt-3"
        [formGroup]="fgPassword" (ngSubmit)="onPasswordSubmit()">
      <p class="fs-normal fw-800 color-gray-950 mb-3">{{'account.change_password'|translate}}</p>

      <div class="row">

        <div class="col-12 col-md-4">
          <label class="color-gray-500 fw-500 fs-small">{{'account.current_password'|translate}}</label>
          <app-gray-password-input
            [hasErr]="passwordIsSubmitted && fgPassword.get('currentPassword')?.invalid"
            icon="lock-bordered" [placeholder]="'account.current_password'|translate"
            formControlName="currentPassword"></app-gray-password-input>
          <div class="form-errors mt-1" *ngIf="passwordIsSubmitted && fgPassword.get('currentPassword')?.errors">
            <p *ngIf="fgPassword.get('currentPassword')?.errors?.required">
              {{'errors.required'|translate}}
            </p>
            <p *ngIf="fgPassword.get('currentPassword')?.errors?.minlength">
              {{'errors.min_char'|translate: {c: 6} }}
            </p>
          </div>
        </div>

        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <label class="color-gray-500 fw-500 fs-small">{{'account.new_password'|translate}}</label>
          <app-gray-password-input
            [hasErr]="passwordIsSubmitted && fgPassword.get('password')?.invalid"
            icon="lock-bordered" [placeholder]="'account.new_password'|translate"
            formControlName="password"></app-gray-password-input>
          <div class="form-errors mt-1" *ngIf="passwordIsSubmitted && fgPassword.get('password')?.errors">
            <p *ngIf="fgPassword.get('password')?.errors?.required">
              {{'errors.required'|translate}}
            </p>
            <p *ngIf="fgPassword.get('password')?.errors?.minlength">
              {{'errors.min_char'|translate: {c: 6} }}
            </p>
            <p *ngIf="fgPassword.get('password')?.errors?.maxlength">
              {{'errors.max_char'|translate: {c: 50} }}
            </p>
          </div>
        </div>

        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <label class="color-gray-500 fw-500 fs-small">{{'account.new_password_confirm'|translate}}</label>
          <app-gray-password-input
            [hasErr]="passwordIsSubmitted && fgPassword.get('rePassword')?.invalid"
            icon="lock-bordered" [placeholder]="'account.new_password_confirm'|translate"
            formControlName="rePassword"></app-gray-password-input>
          <div class="form-errors mt-1" *ngIf="passwordIsSubmitted && fgPassword.get('rePassword')?.errors">
            <p *ngIf="fgPassword.get('rePassword')?.errors?.required">
              {{'errors.required'|translate}}
            </p>
            <p *ngIf="fgPassword.get('rePassword')?.errors?.confirmedValidator">
              {{'errors.no_match_passwords'|translate}}
            </p>
          </div>
        </div>

      </div>

      <div class="form-errors mt-3" *ngIf="passwordErrKey">
        <p>{{passwordErrKey|translate}}</p>
      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-4">
          <app-gray-button
            type="submit" color="primary" [isLoading]="passwordIsLoading" [disabled]="passwordIsLoading"
            [text]="'account.change_password'|translate"></app-gray-button>
        </div>
      </div>

    </form>

    </div>
  </div>

</div>
